var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { GalleryState } from '../../state/gallery.state';
import { Observable } from 'rxjs';
import { GalleryViewMode } from '../../models/gallery-view-mode.enum';
import { GalleryActions } from '../../state/gallery.actions';
var GalleryViewModeComponent = /** @class */ (function () {
    function GalleryViewModeComponent(store) {
        this.store = store;
        this.galleryViewMode = GalleryViewMode;
    }
    GalleryViewModeComponent.prototype.ngOnInit = function () {
    };
    GalleryViewModeComponent.prototype.handleViewModeClick = function (viewMode) {
        this.store.dispatch(new GalleryActions.SetViewMode(viewMode));
    };
    __decorate([
        Select(GalleryState.getViewMode),
        __metadata("design:type", Observable)
    ], GalleryViewModeComponent.prototype, "viewMode$", void 0);
    return GalleryViewModeComponent;
}());
export { GalleryViewModeComponent };
